import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import styled from 'styled-components';

const Styles = styled.div``;

const SelectSituacionExterna = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    defaultProps
}) => {
    const [selectedValue, setSelectedValue] = useState(value);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    const options = [
        {
            value: 'Sin Energia',
            label: 'Sin Energia'
        },
        {
            value: 'Poste Caido',
            label: 'Poste Caido'
        },
        {
            value: 'Camara Vandalizada',
            label: 'Camara Vandalizada'
        },
        {
            value: 'Poste en mal estado',
            label: 'Poste en mal estado'
        },
        {
            value: 'Poste con abejas',
            label: 'Poste con abejas'
        },
    ];

    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }
    }, [value]);

    return (
        <Styles>
            <Select
                {...defaultProps}
                inputId={id}
                className={`react-select-container ${
                    isInvalid ? 'is-invalid' : ''
                }`}
                styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
                menuPortalTarget={document.body}
                classNamePrefix="react-select"
                placeholder="Seleccione..."
                options={options}
                value={selectedValue}
                onChange={onSelectValue}
                isClearable={isClearable}
            />
        </Styles>
    );
};

SelectSituacionExterna.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectSituacionExterna;